__webpack_require__.p = "https://educore.education/admission-form-v2/artal/";